import React, { useEffect, useState } from 'react'
import HospitalSidebar from '../../components/HospitalSidebar/HospitalSidebar'
import { useDispatch, useSelector } from 'react-redux';
import { hospitalActions, userActions } from '../../_actions';
import LoadingOverlay from 'react-loading-overlay';
import { Table, TableHead, TableRow, TableCell, TableBody, Paper, Typography } from '@mui/material';
import { TextareaAutosize, Button, Container, } from '@mui/material';
import { FaRegFilePdf } from "react-icons/fa";
import ReactPaginate from 'react-paginate';
import EditPaymentModel from './Components/EditPaymentModel';

export default function PaymentHospital() {
  let dispatch = useDispatch()
  let selector = useSelector(state => state)
  let { loading } = selector?.dashboard
  let data = {
    "keyWord": "",
    "pageNo": 1,
    "size": 10
  }

  console.log(loading)
  const [open, setOpen] = React.useState(false);
  const [opens, setOpens] = React.useState(false);
  useEffect(() => {
    dispatch(hospitalActions.getHospitalProfile());
    dispatch(userActions.getSubscriptionRequestListHospital(data))
  }, [])

  let { SubscriptionList,

  } = selector&&selector?.users;
  let handleEditModel = () => {
    setOpens(!opens)
  }
   //--------Pagination-------------------------
   const [size, setSize] = useState(10);
   const [isMobile, setIsMobile] = useState(true);
  //--------Pagination-------------------------
 let [offset,setoffset] = useState(0)
   const handlePageClick = (data) => {
     setoffset(Math.ceil(data.selected * 10))
     let datas = {
       "keyWord": "",
       "pageNo": data.selected + 1,
       "size": 10
     }
     dispatch(userActions.getSubscriptionRequestListHospital(datas))
   };
   //--------Pagination-------------------------
console.log(SubscriptionList)
  return (

    <div className='flex'>
      <div >
        <LoadingOverlay
          active={loading}
          className="temp001"
          spinner
          text='Please wait...' />
      </div>
      <div>
        <HospitalSidebar />
      </div>
      <div className='w-full'>


        <div className='w-full text-[#005F60] p-2 md:text-3xl text-2xl font-bold flex'>
          Payments History
          <EditPaymentModel opens={opens} setOpens={setOpens} />
        </div>
        <div className='flex flex-col'>
          <div className='m-2 bg-gray-200 text-lg font-bold rounded-sm overflow-x-auto'>

            {/* <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Description</TableCell>
                  <TableCell>Date</TableCell>

                  <TableCell>Amount</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Image</TableCell>

                </TableRow>
              </TableHead>
              <TableBody>
                {patientPayments.map((payment) => (
                  <TableRow key={payment.id}>
                    <TableCell style={{ whiteSpace: 'nowrap', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      sdsdbfklbsd klabsdl ddddsaddddddddsdfsdfd dddddddddsfsdf dsfddddd
                    </TableCell>
                    <TableCell>{payment.date}</TableCell>

                    <TableCell>${payment.amount}</TableCell>
                    <TableCell>{payment.status}</TableCell>
                    <TableCell>
                      <img
                        className="w-10 h-10"
                        src={
                          "https://plus.unsplash.com/premium_photo-1666532846263-27f1d57550c4?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                        }
                      />
                    </TableCell>

                  </TableRow>
                ))}
              </TableBody>
            </Table> */}

            <Table>
              <TableHead className='bg-[#005F60] rounded-t-md'>
              <TableRow>
                <TableCell style={{ whiteSpace: 'nowrap', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', color: '#fff' }}>#</TableCell>
                  <TableCell style={{ whiteSpace: 'nowrap', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', color: '#fff' }}>Transaction Id</TableCell>
                  <TableCell style={{ whiteSpace: 'nowrap', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', color: '#fff' }}>Date</TableCell>
                  <TableCell style={{ whiteSpace: 'nowrap', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', color: '#fff' }}>Plan Name</TableCell>
                  <TableCell style={{ whiteSpace: 'nowrap', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', color: '#fff' }}>Amount</TableCell>
                  <TableCell style={{ whiteSpace: 'nowrap', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', color: '#fff' }}>Duration</TableCell>
                  <TableCell style={{ whiteSpace: 'nowrap', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', color: '#fff' }}>Payment Mode</TableCell>
                  <TableCell style={{ whiteSpace: 'nowrap', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', color: '#fff' }}>Status</TableCell>
                  <TableCell style={{ whiteSpace: 'nowrap', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', color: '#fff' }}>Image</TableCell>

                </TableRow>
              </TableHead>
              <TableBody className='bg-white'>
                {SubscriptionList?.list&&SubscriptionList?.list.length>0&&SubscriptionList?.list?.map((payment,index) => (
                  <TableRow key={payment.id}>
                         <TableCell style={{ whiteSpace: 'nowrap', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {offset + index+1 || "--"}
                      
                    </TableCell>
                    <TableCell style={{ whiteSpace: 'nowrap', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {payment?.txId || "--"}
                      
                    </TableCell>
                    {/* <TableCell>{payment.date}</TableCell> */}
                    <TableCell>{new Date(payment.date).toLocaleDateString('en-US')}</TableCell>
                    <TableCell>{payment?.packageId?.name || "--"}</TableCell>
                    <TableCell>₹ {payment?.packageId?.amount || "--"}</TableCell>
                    <TableCell>{payment?.packageId?.duration || "--"} Month</TableCell>
                    <TableCell>{payment?.pamentMode || "--"}</TableCell>
                    {payment?.status == 0 && <TableCell className='  text-blue-600 font-bold '>Pending</TableCell>}
                      {payment?.status == 1 && <TableCell className='text-green-600  font-bold'>Approved</TableCell>}
                      {payment?.status == 2 && <TableCell className='text-red-600   font-bold'>Rejected</TableCell>}
                    <TableCell>
                      {/* <img
                        className="w-10 h-10"
                        src={payment?.imageLinkUrl || "--"}
                      /> */}


{payment&&payment?.imageLinkUrl.endsWith('.pdf') ? (
    <FaRegFilePdf className='w-10 h-10 text-red-500' />
  
  ) : (
    <img className='w-10 h-10' src={payment?.imageLinkUrl || "--"} alt='no image' />
  )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <div className='mt-2  flex justify-end items-end w-full'>
            {isMobile ? (
              SubscriptionList?.total && SubscriptionList?.total > 10 ? (
                <ReactPaginate
                  previousLabel={'Prev'}
                  nextLabel={'Next'}
                  breakLabel={'...'}
                  breakClassName={'break-me'}
                  pageCount={Math.ceil(SubscriptionList?.total / size)}
                  marginPagesDisplayed={0}
                  pageRangeDisplayed={2}
                  onPageChange={handlePageClick}
                  containerClassName={'pagination'}
                  pageClassName={'page-cls'}
                  activeClassName={'active'}
                />
              ) : null
            ) : (
              SubscriptionList?.total && SubscriptionList?.total > 10 ? (
                <ReactPaginate
                  previousLabel={'Previous'}
                  nextLabel={'Next'}
                  breakLabel={'...'}
                  breakClassName={'break-me'}
                  pageCount={Math.ceil(SubscriptionList?.total / size)}
                  marginPagesDisplayed={3}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={'pagination'}
                  pageClassName={'page-cls'}
                  activeClassName={'active'}
                />
              ) : null
            )}
          </div>
          </div>
        </div>



      </div>
    </div>




  )
}
